// React
import { useEffect, useState } from 'react'
// MainStem - UI
import { SelectSingle, useOnFirstLoad } from '@mainstem/react-mainstem'
import { ISelectOption } from '@mainstem/react-mainstem/dist/components/Form/Select/types'
// MainStem - API
import { Api } from 'api-new'
// Global - Components
import { LoaderSelect } from 'components/Loader'
// Local - Types
import { ISelectSingleSupplier } from './types'

const mainStemApi = new Api()

const SelectSingleSupplier: React.FC<ISelectSingleSupplier> = ({
  defaultValue,
  label,
  onSelected,
  onlyPrivate = true,
  required
}: ISelectSingleSupplier) => {
  // Loading Indicators
  const [loading, setLoading] = useState<boolean>(true)
  // View State
  const [options, setOptions] = useState<ISelectOption[] | undefined>(undefined)
  const [selectedValue, setSelectedValue] = useState<ISelectOption | undefined>(undefined)

  useEffect(() => {
    if (defaultValue && options) {
      const matchingValue = options.find((option) => option.value === defaultValue)
      setSelectedValue(matchingValue)
    }
  }, [defaultValue, options])

  useOnFirstLoad(() => {
    mainStemApi.api
      .suppliersList({ isPrivate: onlyPrivate ? true : undefined })
      .then((response) => {
        if (response.data.suppliers) {
          const formattedOptions = response.data.suppliers
            .filter((supplier) => !supplier.isArchived)
            .map((supplier) => {
              return {
                label: supplier.name,
                value: supplier.id
              } as ISelectOption
            })

          setOptions(formattedOptions)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  })

  return (
    <>
      {loading || !options ? (
        <LoaderSelect label={label ? label : 'Select a supplier:'} />
      ) : (
        <SelectSingle
          isClearable={true}
          label={label ? label : 'Select a supplier:'}
          labelRequired={required}
          onChange={(newValue) => {
            setSelectedValue(newValue)
            onSelected(newValue)
          }}
          options={options}
          placeholder='Select a supplier'
          value={selectedValue}
        />
      )}
    </>
  )
}

export { SelectSingleSupplier }
